import { createClient } from "@supabase/supabase-js";
import { sharedStorage } from "./utils/sharedStorage";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing Supabase environment variables. Please check your .env file."
  );
}

const COOKIE_NAME = 'fozzil-auth-token';
const cookieStorage = sharedStorage(COOKIE_NAME);

export const { isLocalhost } = cookieStorage;
export const clearAuthCookie = () => cookieStorage.removeItem(COOKIE_NAME);

// ─── Migrate existing localStorage session into cookie ───
// One-time migration so existing logged-in users don't get logged out
if (!isLocalhost && typeof window !== 'undefined') {
  try {
    const existingSession = localStorage.getItem('fozzil-main-auth-token');
    if (existingSession) {
      // Copy to cookie
      cookieStorage.setItem(COOKIE_NAME, existingSession);
      // Clean up old localStorage key
      localStorage.removeItem('fozzil-main-auth-token');
    }
    // Also migrate any legacy sb-* keys
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('sb-') && key.endsWith('-auth-token')) {
        const legacySession = localStorage.getItem(key);
        if (legacySession && !cookieStorage.getItem(COOKIE_NAME)) {
          cookieStorage.setItem(COOKIE_NAME, legacySession);
        }
        localStorage.removeItem(key);
      }
    }
  } catch (e) {
    console.warn('[Migration] Failed to migrate localStorage to cookie:', e);
  }
}

// Supabase Client Initialized
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: COOKIE_NAME,
    storage: cookieStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false // Disabled - we handle URL tokens manually in AuthContext
  }
});
